module.exports = __webpack_public_path__ + "img/water.861cce22.861cce22.png";